module.exports = __webpack_public_path__ + "img/cos-layer.a09c3907.png";